import PropTypes from 'prop-types';

const senderShape = PropTypes.shape({
  fullName: PropTypes.string.isRequired,
});

const messageShape = PropTypes.shape({
  content: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  isRead: PropTypes.bool.isRequired,
  sender: senderShape.isRequired,
});

const conversationShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  lastMessage: messageShape.isRequired,
  subject: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
});

export default conversationShape;
